import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { formatLocalFiatAmount, formatTokenAmount } from '@/config/marketPresentation'
import DescriptionListItem from '@/components/DescriptionListItem'
import { ImageViewerTrigger } from '@/components/ImageViewer'
import SectionHeader from '@/components/SectionHeader'

export function RevisingOrderSection({
  hasHeader = true,
  dealAmount,
  originDealAmount,
  basePrice,
  changeAmountProof
}: {
  hasHeader?: boolean
  dealAmount: { value: string; kind: string }
  originDealAmount: { value: string; kind: string }
  basePrice: string
  changeAmountProof: string[] | null
}) {
  const { t } = useTranslation()
  return (
    <>
      {hasHeader && <SectionHeader>{t('orders:modificationRequest')}</SectionHeader>}
      <DescriptionListItem label={t('orders:originalQuantity')} hasBorderTop={true}>
        {formatTokenAmount(originDealAmount.value)}
      </DescriptionListItem>
      <DescriptionListItem label={t('orders:originalAmount')} hasBorderBottom={true} inset={true}>
        {formatLocalFiatAmount((Number(originDealAmount.value) * Number(basePrice)).toString())}
      </DescriptionListItem>
      <DescriptionListItem label={t('orders:updatedQuantity')} isValuePrimary={true}>
        {formatTokenAmount(dealAmount.value)}
      </DescriptionListItem>
      <DescriptionListItem label={t('orders:updatedAmount')} isValuePrimary={true}>
        {formatLocalFiatAmount((Number(dealAmount.value) * Number(basePrice)).toString())}
      </DescriptionListItem>
      {changeAmountProof !== null && (
        <View className={'gap-1 bg-background-primary px-4 py-2'}>
          <Text className={'text-sm font-semibold text-text-secondary'}>{t('orders:sellerPaymentProof')}</Text>
          <View className={'flex-row gap-2'}>
            {[0, 1, 2].map((element) => (
              <View key={element} className={'h-20 flex-1'}>
                {changeAmountProof.length > element && <ImageViewerTrigger source={changeAmountProof[element]} />}
              </View>
            ))}
          </View>
          <View className={'h-4'} />
        </View>
      )}
    </>
  )
}
